import React, {createContext, useCallback, useMemo, useState} from 'react';
import {VipWebUpgradeModal} from '@fe-progressive/package-progressive/vip-web';
import {useTranslation} from 'react-i18next';
import {checkPopupVipUpgrade} from '../vip.service';
import {useLogin} from '@/utils/state-hooks';

export const VipUpgradeContext = createContext<{
  showVipUpgrade: (cb?: () => void) => void;
}>({
  showVipUpgrade: () => {},
});

export const VipUpgradeProvider = ({children}: {children: React.ReactNode}) => {
  const login = useLogin();
  const {i18n} = useTranslation();
  const [upgradeExperience, setUpgradeExperience] = useState<number | null>(
    null,
  );

  const showVipUpgrade = useCallback(
    (cb?: () => void) => {
      if (!login) {
        return;
      }
      checkPopupVipUpgrade().then(res => {
        if (res.status) {
          setUpgradeExperience(res.changeExperience || 0);
          localStorage.setItem('vipBaseExp', res.changeExperience / 2 + '');
          cb?.();
        }
      });
    },
    [login],
  );

  const contextValue = useMemo(() => ({showVipUpgrade}), [showVipUpgrade]);

  return (
    <VipUpgradeContext.Provider value={contextValue}>
      {children}
      <VipWebUpgradeModal
        visible={upgradeExperience != null}
        amount={upgradeExperience ?? undefined}
        locale={i18n.language}
        onClose={() => setUpgradeExperience(null)}
      />
    </VipUpgradeContext.Provider>
  );
};
